/**
 * useCustomerItineraries Composable
 *
 * Returns itineraries belonging to a specific customer, using the shared
 * itinerary store (respects 5-minute cache). Re-fetches automatically
 * when customerId changes.
 */
import { computed, watch } from 'vue';
import { useItineraryStore } from '../stores/itinerary.store';
// =============================================================================
// COMPOSABLE
// =============================================================================
export function useCustomerItineraries(customerId) {
    const store = useItineraryStore();
    async function load(forceRefresh = false) {
        const id = customerId.value;
        if (!id)
            return;
        try {
            await store.fetchAll(forceRefresh);
        }
        catch {
            // Error is already captured in store.error — no re-throw needed here
        }
    }
    // Kick off the initial load immediately (works inside and outside components)
    load();
    watch(customerId, (id) => {
        if (id)
            load();
    });
    const customerItineraries = computed(() => {
        const id = customerId.value;
        if (!id)
            return [];
        return store.itinerariesByCustomer(id);
    });
    const isLoading = computed(() => store.isLoading);
    const error = computed(() => store.error);
    async function refresh() {
        await load(true);
    }
    return { customerItineraries, isLoading, error, refresh };
}
export default useCustomerItineraries;
